import styled from 'styled-components';

import { HOME_NARROW } from '../../theme/tokens';

/** Stats dashboard column — a single stack with a consistent gap between the
 *  section headers and metric cards. */
export const StatsPage = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/** A section Home deep-links to, as a scroll target: it lands clear of the pinned page header (and a little below
 *  it, so its title reads at once). A grid, so the section still fills a row it shares (Money Flow beside Earnings). */
export const SectionAnchor = styled.div`
  display: grid;
  min-width: 0;
  scroll-margin-top: 146px;
`;

/** Money Flow + Earnings side by side, collapsing to one column at 1120px. */
export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  > * {
    min-width: 0;
  }

  ${HOME_NARROW} {
    grid-template-columns: 1fr;
  }
`;
